import { Link } from "react-router-dom";
import { Info } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";

interface CostOfLivingNoteProps {
  useRpp?: boolean;
}

/**
 * RPP (Regional Price Parity) context note
 * Explains cost of living adjustments
 */
export default function CostOfLivingNote({ useRpp }: CostOfLivingNoteProps) {
  return (
    <Alert className="mb-6">
      <Info className="h-4 w-4" />
      <AlertDescription>
        <strong>Understanding Real vs. Nominal Wages:</strong>{" "}
        {useRpp ? (
          <>
            You're currently viewing <strong>real wages</strong> adjusted for Regional Price Parity (RPP). 
            This shows purchasing power after accounting for cost of living differences. 
            Real wages help you compare salaries across different locations more accurately.
          </>
        ) : (
          <>
            You're currently viewing <strong>nominal wages</strong> (unadjusted for cost of living). 
            Toggle the RPP adjustment above to see real wages, which account for Regional Price Parity 
            and provide a more accurate comparison of purchasing power across different locations.
          </>
        )}{" "}
        <Link to="/real-wages/" className="underline underline-offset-2 whitespace-nowrap">
          How real wages work
        </Link>
      </AlertDescription>
    </Alert>
  );
}

